import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import * as distanceInWordsToNow from 'date-fns/distance_in_words_to_now';
import * as format from 'date-fns/format';
import { NzMessageService, NzNotificationService } from 'ng-zorro-antd';
import { NoticeItem } from '@delon/abc';
import * as SockJS from 'sockjs-client';
import * as Stomp from 'webstomp-client';
import { SettingsService,ALAIN_I18N_TOKEN } from '@delon/theme';
import { Router } from '@angular/router';
import { JyExtendService } from '../../../../routes/workflow/new-flow/newFlow.service';
import { JyExtendOverrideService } from '../../../../routes/workflow/new-flow/newFlowOverride.service';
import { environment } from '@env/environment';
import { ArticleService } from '../../../../routes/jy-content/article/service/article.service';
import { ArticleReaderService } from '../../../../routes/jy-content/article/service/article_reader.service';
import { Pagination } from '../../../../core/bean/pagination';
import { CommonsService } from '../../../../core/service/commons.service';
import { InfoService } from '../../../../routes/jy-content/article/service/info.service';
import { JyMessageService } from '../../../../routes/jy-message/jy-message.service';
import { PersonService } from '../../../../routes/jy-org/person/service/person.service';
import { DictService } from '../../../../routes/jy-dict/dict-info/service/dict.service';
import { CacheService } from '@delon/cache';
import { SupplierViewService } from '../../../../routes/jy-srm/supplier/supplier-view/supplier-view.service';
import { ConfigParaService } from '../../../../routes/jy-srm/basic-data/srm-config/config-info/service/config-para.service';
import { SourceViewSupService } from '../../../../routes/jy-srm/procu-source/source-view-sup/source-view-sup.service';
import { PurchaeService } from '../../../../routes/jy-srm/supplier/supplier-guide/purchase-business-portal/purchae.service';
import {LinkFlowService} from "@shared/components/link-flow/link-flow.service";
import { I18NService } from '@core/i18n/i18n.service';

/**
 * 菜单通知
 */
@Component({
  selector: 'header-notify',
  template: `
    <notice-icon
      [data]="data"
      [count]="getCount()"
      [loading]="loading"
      (select)="select($event)"
      (clear)="clear($event)"
      [(popoverVisible)]="popoverVisible"
      (popoverVisibleChange)="loadData()"></notice-icon>
  `,
})
export class HeaderNotifyComponent implements OnInit, OnDestroy {
  ngOnInit(): void {
    this.srv.set('userType', '');
    this.supplierViewService.isSupplier().subscribe((data) => {
      this.commonsService.isInner = !data;
    });
    this.reloadDictCache();
    this.connect();
    // this.getAgandaCount();
    // this.getArticleCount();
    this.commonsService.getTotalCount();
    // this.count = this.commonsService.count;
    this.getSystemDefaultParams();
    this.purchaeService.get().subscribe((result) => {
        if(result){
          this.popoverVisible = result;
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
          }, 0.5)
        }
    });
  }

  reloadDictCache() {
    let version = this.srv.getNone('dictVersion');
    let serverVersion = this.dictService.getVersion().subscribe((data) => {
      if (version != data['version']) {
        this.srv.clear();
        this.srv.set('dictVersion', data['version']);
      }
    });
  }

  ngOnDestroy(): void {
    this.disconnect();
  }

  popoverVisible = false;
  greetings: string[] = [];
  disabled = true;
  name: string;
  private stompClient = null;
  articleVisible: boolean = false;
  article: any = {
    content: {
      contents: '',
    },
  };
  pagination: Pagination = new Pagination();

  constructor(private notification: NzNotificationService, private settingService: SettingsService,
              private msg: NzMessageService, private router: Router, private jyExtendService: JyExtendService,
              private commonsService: CommonsService,
              private srv: CacheService,
              private dictService: DictService,
              private supplierViewService: SupplierViewService,
              private articleService: ArticleService, private articleReaderService: ArticleReaderService,
              private infoService: InfoService,
              private jyMessageService: JyMessageService,
              private personService: PersonService,
              private configParaService: ConfigParaService,
              private sourceViewSupService: SourceViewSupService,
              private purchaeService: PurchaeService,
              private jyExtendOverrideService:JyExtendOverrideService,
              private linkFlowService:LinkFlowService,
              @Inject (ALAIN_I18N_TOKEN) private i18n: I18NService
              ) {
    this.i18n.change.subscribe( () => {
      this.data[0].title = this.commonsService.translate('notice.workflow');
      this.data[0].emptyText = this.commonsService.translate('notice.workflowNull');
      this.data[0].clearText = this.commonsService.translate('notice.viewAll');
      this.data[1].title = this.commonsService.translate('notice.info');
      this.data[1].emptyText = this.commonsService.translate('notice.infoNull');
      this.data[1].clearText = this.commonsService.translate('notice.viewAll');
    })
  }

  setConnected(connected: boolean) {
    this.disabled = !connected;

    if (connected) {
      this.greetings = [];
    }
  }

  connect() {
    const socket = new SockJS(environment.SERVER_URL + 'ws-point');
    this.stompClient = Stomp.over(socket);
    const _this = this;
    // this.disconnect(_this);
    this.stompClient.connect({}, function(frame) {
      _this.setConnected(true);
      console.log('Connected: ' + frame);
      //广播消息订阅
      _this.stompClient.subscribe('/topic/tipMessage', function(data) {
        if (data.body) {
          let wsNotice = JSON.parse(data.body);
          //处理其他动作
          if (wsNotice['otherActions']) {
            //字典清空
            if (wsNotice['otherActions'].indexOf('clearDict') > -1) {
              _this.srv.clear();
              _this.srv.set('dictVersion', (wsNotice['otherActions'].split('-'))[1]);
            }
          } else {
            _this.commonsService.getArticleCount();
            if (_this.personService.currentPerson && _this.personService.currentPerson.sysMsgSwitch) {
              _this.showMessage(wsNotice);
            }
          }
        }
      });
      //用户消息订阅
      _this.stompClient.subscribe('/user/' + _this.settingService.user['id'] + '/queue/notifications', function(data) {
        if (data.body) {
          let wsNotice = JSON.parse(data.body);
          if (wsNotice['otherActions']) {
            //进度条
            if (wsNotice['otherActions'].indexOf('processBar') > -1) {
              _this.srv.set((wsNotice['otherActions'].split('-'))[0], (wsNotice['otherActions'].split('-'))[1]);
            }
          } else {
            _this.commonsService.getArticleCount();
            if (_this.personService.currentPerson && _this.personService.currentPerson.sysMsgSwitch) {
              _this.showMessage(wsNotice);
            }
          }
        }
      });
    });
  }

  disconnect() {
    this.notification.remove();
    try {
      if (this.stompClient != null) {
        this.stompClient.disconnect();
      }
      this.setConnected(false);
      console.log('Disconnected!');
    } catch (e) {
      console.log(e);
    }

  }

  /**
   * 显示消息
   * @param wsMessage
   */
  showMessage(wsMessage): void {
    //若消息动作为刷新页面,则调用刷新页面的方法
    if ('101' == wsMessage['actions']) {
      //wsMessage['title'], wsMessage['description']
      this.sourceViewSupService.sendMomentOffer(wsMessage);
    }
    //存在标题时,进行提示
    if (wsMessage['title']) {
      this.notification.config({
        nzPlacement: 'topRight',
      });
      var iconType = 'info';
      if (wsMessage['type']) {
        iconType = wsMessage['type'];
      }
      this.notification.create(iconType, wsMessage['title'], wsMessage['description']);
    }
    //消息数量
    if (wsMessage['countChangeType']) {
      if ('1' == wsMessage['countChangeType']) {
        this.commonsService.count = this.commonsService.count + 1;
      } else if ('2' == wsMessage['countChangeType']) {
        this.commonsService.count > 0 ? (this.commonsService.count = this.commonsService.count - 1) : this.commonsService.count;
      } else if ('3' == wsMessage['countChangeType']) {
        this.commonsService.getAgandaCount();
      }
    }

  }
  data: NoticeItem[] = [
    {
      title: this.commonsService.translate('notice.workflow'),
      list: [],
      emptyText: this.commonsService.translate('notice.workflowNull'),
      emptyImage: 'https://gw.alipayobjects.com/zos/rmsportal/HsIsxMZiWKrNUavQUXqx.svg',
      clearText: this.commonsService.translate('notice.viewAll'),
    },
    {
      title: this.commonsService.translate('notice.info'),
      list: [],
      emptyText: this.commonsService.translate('notice.infoNull'),
      emptyImage: 'https://gw.alipayobjects.com/zos/rmsportal/wAhyIChODzsoKIOBHcBk.svg',
      clearText: this.commonsService.translate('notice.viewAll'),
    },
  ];

  // count: number = 0;
  workFlowCount: number = 0;
  articleCount: any = 0;
  loading = false;

  /*calTotalCount() {
    this.count = this.workFlowCount + parseInt(this.articleCount);
  }*/

  /**
   * 获取消息数量
   */
  /*getArticleCount() {
    this.infoService.getUnreadCount().subscribe((data) => {
      this.articleCount = data;
      this.calTotalCount();
    });
  }*/

  /**
   * 获取待办数量
   */
  /*getAgandaCount() {
    this.jyExtendService.sendBackLog().subscribe((datas) => {
      this.workFlowCount = datas['totalCount'];
      this.calTotalCount();
    });

  }*/

  loadData() {
    if (this.loading) return;
    if (!this.popoverVisible) {
      (this.data)[0].list = [];
      (this.data)[1].list = [];
      return;
    }
    // this.getAgandaCount();
    // this.getArticleCount();
    this.commonsService.getTotalCount();
    this.loading = true;
    //延迟0.2秒防止闪烁
    setTimeout(() => {
      (this.data)[0].list = [];
      this.jyExtendOverrideService.sendBackLogOverride().subscribe((datas) => {
        this.workFlowCount = datas.totalCount;
        datas['content'].forEach(data => {
          let dataItem = {
            id: data.id,
            requestId:data.requestId,
            title: data.title,
            description: this.commonsService.translate('msg.splice.by') + data['name'] + this.commonsService.translate('msg.splice.to') + format(data['createdDate'], 'YYYY-MM-DD HH:mm:ss') + this.commonsService.translate('msg.splice.currentNode') + '[' + (data['workflowNodeBase'])['nodeName'] + '] ',
            datetime: distanceInWordsToNow(data.createdDate, {
              locale: (window as any).__locale__,
            }),
            extra: (((data['workflowNodeBase'])['workflowBase'])['workflowType'])['name'],
            color: 'blue',
          };
          (this.data)[0].list.push(dataItem);
        });
        this.loading = false;
        // this.articleReaderService.headerQuery(5).subscribe((_datas)=> {
        //   this.articleCount = _datas.headers.get('X-Total-Count');
        //   _datas.body.forEach(_data=> {
        //     let dataItem = {
        //       id: _data.id,
        //       title: (_data['article'])['title'],
        //       description: '由' + _data['createdBy'] + '于' + format(_data['createdDate'], 'YYYY-MM-DD HH:mm:ss') + '发起.',
        //       datetime: distanceInWordsToNow(_data.createdDate, {
        //         locale: (window as any).__locale__,
        //       }),
        //       extra: (_data['article'])['categoryName'],
        //       color: 'green'
        //     };
        //     (this.data)[1].list.push(dataItem)
        //   });
        //   this.calTotalCount();
        //   this.loading = false;
        // })
      });
      (this.data)[1].list = [];
      this.jyMessageService.getNoticeData().subscribe((datas) => {
        datas.forEach(data => {
          let des = data.information.description;
          if(des.indexOf('</a>') > -1 && des.indexOf('<a') > -1){
            let des3 = des.split('</a>')[1];
            des = des.split('</a>')[0];
            let des1 = des.split('<a')[0];
            let des2 = des.split('>')[1];
            des = des1 + des2 + des3;
          }
          let dataItem = {
            id: data.id,
            title: data.information.title,
            description: des,
            datetime: distanceInWordsToNow(data.createdDate, {
              locale: (window as any).__locale__,
            }),
            type: data.information.type,
            url: data.information.url,
            information: data.information,
            color: 'blue',
          };
          (this.data)[1].list.push(dataItem);
        });
      });
    }, 200);

  }

  /**
   * 查看通知
   * @param articleId
   * @param articleReaderId
   */
  viewArticle(res) {
    if (res.item.type != 0) {
      this.infoService.view(res.item.id).subscribe(() => {
        // this.getArticleCount();
        this.commonsService.getArticleCount();
      });
      this.jyMessageService.readMessage(res.item);
    } else {
      if(res.item.information && res.item.information.description && res.item.information.description.indexOf('</a>') > -1 && res.item.information.description.indexOf('<a') > -1){
        let str = res.item.information.description.split('</a>')[0];
        if(str){
          str = str.split('href=')[1];
          if(str){
            str = str.split('>')[0];
            str = str.replace(/"/g, "");
            str = str.replace(/'/g, "");
            if(str){
              str = str.split('/#')[1];
            }
            this.router.navigateByUrl(str);
          }
        }

      }else{
        this.router.navigateByUrl('/system-msg/log/notice');
      }

    }
  }

  /**
   * 关闭通知
   */
  handleCancel(): void {
    this.articleVisible = false;
  }

  /**
   * 查看全部
   * @param type
   */
  clear(type: string) {
    switch (type) {
      case ((this.data)[0].title):
        this.router.navigate(['/workflow/backlogFlow']);
        break;
      case ((this.data)[1].title):
        this.router.navigate(['/system-msg/log/notice']);
        break;
    }
    this.popoverVisible = false;
    // this.msg.success(`清空了 ${type}`);
  }

  /**
   *
   */
  getCount():number{
    return this.commonsService.count;
  }
  /**
   * 选择
   * @param res
   */
  select(res: any) {
    if (res.title == ((this.data)[1].title)) {
      this.viewArticle(res);
    }else if(res.title == ((this.data)[0].title)){
      let obj = {
        requestId:res.item.requestId,
        iconName:'anticon anticon-appstore',
      };
      let paramStr = JSON.stringify(obj);
      this.router.navigateByUrl('/srm-workflow;searchData=' + paramStr);
      // this.linkFlowService.get(res.item.requestId).subscribe((data) => {
      //
      // });
    }
    this.popoverVisible = false;

    // let toUserIds = [];
    // toUserIds.push("1");
    // toUserIds.push("1000004");
    // this.stompClient.send(
    //   '/ws/point',
    //   JSON.stringify({
    //     'title': '测试流程提醒',
    //     'description': '由admin于2018-10-8发起请假流程需要处理',
    //     'toUserIds': toUserIds,
    //     'countChangeType': '1'
    //   })
    // );
    // this.msg.success(`点击了 ${res.title} 的 ${res.item.title}`);
  }

//获取系统预制默认参数 propertyNames=configPara.id&propertyValues=1000100
  getSystemDefaultParams() {
    this.configParaService.getWithItemList('defaultManage').subscribe((data) => {
      let defaultParam: any = {};
      if (data.configParaDts) {
        data.configParaDts.forEach((item) => {
          defaultParam[item.typeCode] = item.paraValue1;
        });
      }
      this.commonsService.systemDefaultParams = defaultParam;
    });
  }
}
